
import React from 'react'

const FilterIcon = ({ className }) => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                enableBackground="new 0 0 512 512"
                viewBox="0 0 189.524 189.524"
                className={className}
            >
                <path
                    fillRule="evenodd"
                    d="M56.26 52.119c-2.104 8.174-9.524 14.214-18.355 14.214-10.467 0-18.952-8.485-18.952-18.952s8.485-18.952 18.952-18.952c8.831 0 16.251 6.04 18.355 14.214h128.526a4.738 4.738 0 010 9.476zm-8.879-4.738a9.476 9.476 0 11-9.476-9.476 9.476 9.476 0 019.476 9.476z"
                    clipRule="evenodd"
                    data-original="#5b6b79"
                ></path>
                <path
                    d="M4.738 52.119h14.811c-.39-1.514-.597-3.102-.597-4.738s.207-3.224.597-4.738H4.738a4.738 4.738 0 100 9.476z"
                    data-original="#5b6b79"
                ></path>
                <path
                    fillRule="evenodd"
                    d="M113.117 137.405c-2.104-8.174-9.525-14.214-18.355-14.214s-16.252 6.04-18.355 14.214H4.738a4.738 4.738 0 000 9.476h71.668c2.104 8.174 9.525 14.214 18.355 14.214s16.252-6.04 18.355-14.214h71.668a4.739 4.739 0 000-9.476zm-18.355 14.214c5.234 0 9.476-4.242 9.476-9.476s-4.242-9.476-9.476-9.476-9.476 4.242-9.476 9.476 4.242 9.476 9.476 9.476zm75.212-61.595c-2.104-8.174-9.525-14.214-18.355-14.214s-16.252 6.04-18.355 14.214H4.738a4.738 4.738 0 000 9.476h128.526c2.104 8.174 9.525 14.214 18.355 14.214s16.252-6.04 18.355-14.214h14.811a4.739 4.739 0 000-9.476zm-18.355 14.214c5.234 0 9.476-4.242 9.476-9.476s-4.243-9.476-9.476-9.476c-5.234 0-9.476 4.242-9.476 9.476s4.242 9.476 9.476 9.476z"
                    clipRule="evenodd"
                    data-original="#5b6b79"
                ></path>
            </svg>
        </>
    )
}

export default FilterIcon
